import React, { useState, useEffect } from 'react';

import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import './Footer.scss';

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formErrors, setformErrors] = useState({});
  

  
  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setformErrors(validate(formData));
    setLoading(true);
    
    

    const contact = {
      _type: 'contact',
      name: formData.username,
      email: formData.email,
      message: formData.message,
    };

    client.create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((err) => console.log(err));

  }

  useEffect(() =>{
    console.log(formErrors);
      if(Object.keys(formErrors).length === 0 && isFormSubmitted) {
        console.log(formData);
      }
  }, [formErrors])




  const validate = (values) => {
    const errors = {}
    const regex= /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if(!values.username) {
      errors.username = "Hey! Tell me your name."
    }
    if(!values.email) {
      errors.email = "Email is required!"
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }
    if(!values.message) {
      errors.message = "Put some message, its required!"
    }
    return errors;
  };




  
  return (
      <>
        <h2 className="head-text">Take a coffee & chat with me</h2>

        <div className="app__footer-cards">
        <div className="app__footer-card ">
          <img src={images.email} alt="email" />
          <a href="mailto:danyalakhtarofficial@gmail.com" className="p-text">danyalakhtarofficial@gmail.com</a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="phone" />
          <a href="tel:+91 8982808670" className="p-text">+91 8982808670</a>
        </div>
        <div className="app__footer-card">
          <img src={images.watsapp} alt="watsapp" />
          <a href="https://api.whatsapp.com/send?phone=+918982808670&text=Hello Danyal! hope you are doing great. Lets connect and talk more!" className="p-text">Chat on watsapp</a>
        </div>
        <div className="app__footer-card">
          <img src={images.linkedin} alt="linkedin" />
          <a href="https://www.linkedin.com/in/danyal-akhtar-02ba40168" className="p-text">Connect on Linkedin</a>
        </div>
      </div>
       
      {/* {!isFormSubmitted ? ( */}
      {Object.keys(formErrors).length === 0 && isFormSubmitted ? (<div>
          <h3 className="head-text">
           Thank you for getting in touch!
        </h3>
         </div>) : (
           
         
        <div className="app__footer-form app__flex">
          
          <div className="app__flex">
            <input className="p-text" type="text" placeholder="Your Name"   name="username" value={username} onChange={handleChangeInput} />
          </div>
          <p>{ formErrors.username }</p>
          
          <div className="app__flex">
            <input className="p-text" type="email" placeholder="Your Email"  name="email" value={email} onChange={handleChangeInput}  />
          </div>
          <p>{ formErrors.email }</p>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
              
            />
          </div>
          <p>{ formErrors.message }</p>
          
          <button type="button" className="p-text" onClick={handleSubmit}>{!loading ? 'Send Message' : 'Sending...'}</button>
        </div>    
         )}
        
        {/* ) : ( 
         <div>
          <h3 className="head-text">
           Thank you for getting in touch!
        </h3>
         </div>
      )}  */}

      
      </>
  )
 }


export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);